import { Grid, useMediaQuery, useTheme } from "@material-ui/core";
import { Block, Save } from "@material-ui/icons";
import Config, {
  IS_CHECK_MANY_CHECKIN_ON_DAY,
  POSITION_CONSULTANT,
} from "app/appConfig";
import CommonButton from "app/common/Component/Button/CommonButton";
import PatientComplainChip from "app/common/Component/PatientComplainChip";
import PopupForm from "app/common/Component/Popup/PopupForm";
import FormikFocusError from "app/common/form/FormikFocusError";
import GlobitsCheckBox from "app/common/form/GlobitsCheckBox";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsSelectInput from "app/common/form/GlobitsSelectInput";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import GlobitsConfirmationDialog from "app/common/GlobitsConfirmationDialog";
import IconUserEdit from "app/common/Icon/IconUserEdit";
import { MARKETING_TYPE, PathModule } from "app/common/LocalConst";
import {
  getDepartmentsUser,
  getSystemConfig,
  isAdmin,
  transformDate,
  withNameSpace,
} from "app/common/LocalFunction";
import ConsultantTableSection from "app/PatientManagement/CheckInList/Popup/ConsultantTableSection";
import { pagingDepartment } from "app/services/DepartmentService";
import { pagingStaff } from "app/services/StaffService";
import { pagingVisitType } from "app/services/VisitTypeService";
import { useStore } from "app/stores";
import { useFormikContext } from "formik";
import history from "history.js";
import { observer } from "mobx-react";
import { memo, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { CompanionAutocomplete, CompanionInitializationEffect } from "app/PatientManagement/CheckInList/Component/CompanionAutocomplete";
// import LeadSearchPopup from "../../PatientList/Popup/LeadSearchPopup";

/*
* Thêm mới check in trong khách hàng
*/
const CheckInPopup = ({
  open,
  handleClose,
  handleSubmit,
  nameSpace = "",
  initialValues,
  handleAfterSubmit,
  handleSearchDuplicateInPersonal,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const isAdminRole = isAdmin();
  const departmentsUser = getDepartmentsUser();
  const validationSchema = Yup.object({
    issueDate: Yup.date()
      .transform(transformDate)
      .typeError("Thời gian check in không đúng định dạng!")
      .nullable()
      .required("Thời gian check in không được bỏ trống!")
      .test(
        "issueDate-maxDate",
        "Không được nhập quá thời gian hiện tại",
        function (value) {
          if (!value) return true;
          const now = new Date();
          return value <= now;
        },
      ),

    department: Yup.object()
      .nullable()
      .required("Cơ sở check in không được bỏ trống!"),
    patient: Yup.object().shape({
      phoneNumber: Yup.string()
        .trim()
        .required("Vui lòng nhập số điện thoại")
        .matches(/^\d{9,19}$/, "Số điện thoại không hợp lệ"),
    }),
    listConsultant: Yup.array()
      .test(
        "require-consultant-checkin",
        "Phải chọn ít nhất 1 nhân viên tư vấn",
        function (value) {
          const require =
            getSystemConfig("REQUIRE_CONSULTANT_CHECKIN") === true ||
            window.Configs?.REQUIRE_CONSULTANT_CHECKIN === true;

          if (!require) return true;

          return Array.isArray(value) && value.length > 0;
        },
      )
      .of(
        Yup.object().shape({
          staff: Yup.object()
            .nullable()
            .required("Vui lòng chọn nhân viên tư vấn"),
        }),
      ),
  });

  const isPatientGeneral = window.location.pathname.includes("patient-general");

  const handleCheckDuplicate = async () => {
    let data = [];
    if (handleSearchDuplicateInPersonal) {
      data = await handleSearchDuplicateInPersonal({
        phoneNumber: initialValues?.patient?.phoneNumber,
        searchArchive: false,
        // truyền tạm biến này qua search để khi chọn patient thì gán lại sau,
        dataValue: {
          ...initialValues,
          checkTypeVisit: initialValues?.visitType,
        },
      });
    }
    return data;
  };
  useEffect(() => {
    if (initialValues?.patient?.phoneNumber) {
      handleCheckDuplicate();
    }
  }, [initialValues?.patient?.phoneNumber]);

  return (
    <PopupForm
      open={open}
      size="sm"
      handleClose={handleClose}
      title={"Check in khách hàng"}
      formik={{
        initialValues: initialValues,
        onSubmit: async (values, { setSubmitting }) => {
          if (!values?.leadId) {
            const duplicatePatient = await handleCheckDuplicate();
            console.log("duplicatePatient", duplicatePatient);

            if (!duplicatePatient || duplicatePatient?.length == 0) {
              // kể cả ko tìm thấy thì cho submit
              handleSubmit(values, { setSubmitting });
              if (handleAfterSubmit) {
                handleAfterSubmit();
              }
            }
          } else {
            handleSubmit(values, { setSubmitting });
            if (handleAfterSubmit) {
              handleAfterSubmit();
            }
          }
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
      }}
      action={({ submitForm, setFieldValue, isSubmitting }) => {
        return (
          <div className="flex-center gap-1">
            {!initialValues?.visitId && !isPatientGeneral && (
              <CommonButton
                className="btn-add"
                onClick={async () => {
                  setFieldValue("redirect", true);
                  await submitForm();
                }}
                disabled={isSubmitting}
              >
                {!isMobile && <IconUserEdit className="mr-2 " />}
                Check In & mở hồ sơ
              </CommonButton>
            )}
            <CommonButton
              disabled={isSubmitting}
              type="submit"
              className="btn-primary"
            >
              {!isMobile && <Save className="mr-2 " />}
              Check In
            </CommonButton>

            <CommonButton className="btn-gray" onClick={handleClose}>
              {!isMobile && <Block className="mr-2" />}
              Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      {({ setFieldValue, values, setSubmitting }) => {
        return (
          <>
            <FormikFocusError />
            <Grid container spacing={1} className="w-100 m-0">
              {!values?.lead && !values?.leadId && (
                <Grid item xs={12} sm={6}>
                  <GlobitsCheckBox
                    label="Có người đi kèm"
                    name="isCompanions"
                    style={{
                      fontSize: "14px",
                      height: "100%",
                    }}
                  />
                </Grid>
              )}
              <Grid item xs={12} sm={6}>
                <GlobitsCheckBox
                  label="Có người đi cùng"
                  name="isCompanion"
                  style={{
                   fontSize: "14px",
                    height: "100%",
                  }}
                />
              </Grid>

              <CompanionInitializationEffect />
              {values?.isCompanion && (
                <Grid item xs={12} sm={12}>
                  <CompanionAutocomplete />
                </Grid>
              )}
              <Grid item xs={12} sm={12}>
                <PhoneNumberSearch />
              </Grid>

              {values?.patient?.displayName && (
                <Grid item xs={12} sm={12}>
                  <div className="flex align-center flex-wrap gap-1">
                    <strong>
                      {values.patient.displayName}
                      {values?.patient?.code ? ` (${values.patient.code})` : ""}
                    </strong>
                    <PatientComplainChip
                      complainStatus={values?.patient?.complainStatus}
                    />
                  </div>
                </Grid>
              )}


              <Grid item xs={12} sm={12}>
                <GlobitsPagingAutocomplete
                  name={withNameSpace("department", nameSpace)}
                  label={t("Cơ sở check in")}
                  api={
                    isAdminRole
                      ? pagingDepartment
                      : async () => ({
                          data: {
                            content: departmentsUser || [],
                            totalElements: departmentsUser?.length || 0,
                            totalPages: 1,
                          },
                        })
                  }
                  autoUpercase
                  required
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <GlobitsPagingAutocomplete
                  name={withNameSpace("receptionist", nameSpace)}
                  label={t("Người check in")}
                  api={pagingStaff}
                  autoUpercase
                  displayLabel="staffName"
                  searchObject={{
                    departmentId: values?.department?.id,
                    positionCode: POSITION_CONSULTANT,
                    isActive: true,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <GlobitsDateTimePicker
                  label={t("Thời gian check in")}
                  name={withNameSpace("issueDate", nameSpace)}
                  isDateTimePicker
                  maxDate={new Date()}
                  maxDateMessage="Thời gian check in phải trước thời gian hiện tại"
                  required
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <GlobitsPagingAutocomplete
                  name={"visitType"}
                  label={"Loại check in"}
                  api={pagingVisitType}
                />
              </Grid>

              {values?.leadId && (
                <Grid item xs={12} sm={12}>
                  <GlobitsSelectInput
                    label={t("Loại khách")}
                    name={"marketingType"}
                    options={MARKETING_TYPE}
                    disabled={!isAdminRole}
                  />
                </Grid>
              )}

              <Grid item xs={12} sm={12}>
                <ConsultantTableSection />
              </Grid>
            </Grid>
            <DialogCheckIn
              handleSubmit={handleSubmit}
              handleClose={handleClose}
              isPatientGeneral={isPatientGeneral}
            />

            <DialogHasAppointment
              handleSubmit={handleSubmit}
              handleClose={handleClose}
            />
          </>
        );
      }}
    </PopupForm>
  );
};

const DialogCheckIn = observer(
  ({ handleSubmit, handleClose, isPatientGeneral }) => {
    const { values, setSubmitting } = useFormikContext();
    const { openConfirmCheckIn, setOpenConfirmCheckIn } =
      useStore().patientManagementStore.patientListStore;
    return (
      <>
        {openConfirmCheckIn && (
          <GlobitsConfirmationDialog
            title="Tiếp tục check in!"
            text={openConfirmCheckIn}
            onConfirmDialogClose={() => {
              setOpenConfirmCheckIn(null);
            }}
            onYesClick={async () => {
              await handleSubmit(
                { ...values, skipCheckValiate: true },
                { setSubmitting },
              );
              setOpenConfirmCheckIn(null);
            }}
            {...(isPatientGeneral
              ? {}
              : {
                  textConfirmButtonSecond: "Mở hồ sơ",
                  onConfirmButtonSecond: () => {
                    setOpenConfirmCheckIn(null);
                    handleClose();
                    history.push(
                      Config.ROOT_PATH +
                        PathModule.PATIENT_MANAGEMENT +
                        `/patient-general?patientId=${values?.patient?.id}`,
                    );
                  },
                })}
            cancel="Hủy"
            {...(IS_CHECK_MANY_CHECKIN_ON_DAY ? { agree: "Tiếp tục" } : {})}
            open={!!openConfirmCheckIn}
          />
        )}
      </>
    );
  },
);

const DialogHasAppointment = observer(
  ({ handleSubmit, handleClose, isPatientGeneral }) => {
    const { values, setSubmitting } = useFormikContext();
    const { openConfirmHasAppointment, setOpenConfirmHasAppointment } =
      useStore().patientManagementStore.patientListStore;
    return (
      <>
        {!!openConfirmHasAppointment && (
          <GlobitsConfirmationDialog
            maxWidth={"sm"}
            title="Tiếp tục check in!"
            text={openConfirmHasAppointment?.responseDetail}
            onConfirmDialogClose={() => {
              setOpenConfirmHasAppointment(null);
            }}
            onYesClick={async () => {
              await handleSubmit(
                {
                  ...values,
                  appointmentId: openConfirmHasAppointment?.appointmentId,
                  skipCheckValiate: true,
                },
                { setSubmitting },
              );
              setOpenConfirmHasAppointment(null);
            }}
            cancel="Hủy"
            agree="Cập nhật lịch"
            open={!!openConfirmHasAppointment}
          />
        )}
      </>
    );
  },
);

const PhoneNumberSearch = observer(() => {
  const { handleSearchDuplicateInPersonal } =
    useStore().patientManagementStore.patientListStore;
  const { values, setFieldValue } = useFormikContext();
  const handlePhoneNumberChange = async (phoneNumber, values) => {
    if (phoneNumber && phoneNumber?.length >= 10) {
      const data = await handleSearchDuplicateInPersonal({
        phoneNumber,
        searchArchive: false,
        // truyền tạm biến này qua search để khi chọn patient thì gán lại sau,
        dataValue: { ...values, checkTypeVisit: values?.visitType },
      });
    }
  };
  return (
    <>
      <GlobitsTextField
        name={"patient.phoneNumber"}
        label="Số điện thoại"
        autoUpercase
        required
        onChange={async (e) => {
          const phoneNumber = e.target.value;
          setFieldValue("patient.phoneNumber", phoneNumber);
          await handlePhoneNumberChange(phoneNumber, values);
        }}
      />
    </>
  );
});

export default memo(observer(CheckInPopup));
